<template>
    <AppLayout class="patient-registation-form">
        <BaxHeaderBannerSimple :user="this.$store.state.auth.user" :containerClass="'full-page'">
        New Home Patient Registration
        </BaxHeaderBannerSimple>
        <div class="patient-registration-notice" v-if="deletedConfirmationMessage">
            <div class="container full-page">
                <p>{{this.deletedConfirmationMessage}}</p>
            </div>
        </div>
        <main>
            <div class="bax-section">
                <div class="container full-page" v-if="asyncDataLoaded === true">
                    <div class="patient-register-intro-section" v-if="showIntro === true">
                        <div class="intro">
                            <h3>Register a new Home Patient</h3>
                            <button type="button" class="bax-btn bax-btn-blue-brand" @click.prevent="onstartPatientRegistration()">Start a new registration</button>
                        </div>
                        <div class="applications-list">
                            <h4>Draft Registrations</h4>
                            <div class="table-wrapper">
                                <table>
                                    <tr>
                                        <th class="left-aligned">Patient name</th>
                                        <th>DOB</th>
                                        <th>Type</th>
                                        <th class="left-aligned">Last modified</th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                    <tr v-for="(application, index) in draftApplications" :key="index">
                                        <td class="left-aligned">{{ application.name }}</td>
                                        <td>{{ application.dob }}</td>
                                        <td>{{ application.type }}</td>
                                        <td class="left-aligned">{{ application.modified }}</td>
                                        <td class="icons">
                                            <button type="button" class="btn-application-action btn-application-edit" @click.prevent="onEditApplication(application.id)"></button>
                                        </td>
                                        <td class="icons">
                                            <button type="button" class="btn-application-action btn-application-delete" @click.prevent="onDeleteApplication(application)"></button>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <p>Draft registrations will be saved for 7 days. Drafts can be edited by any of your colleagues who use BOLT.</p>
                        </div>
                    </div>
                    <div class="patient-register-section" v-if="showIntro === false">
                        <div class="steps-container">
                            <ul>
                                <li class="step-item" :class="{ 'past': step.number < currentStep || formSubmittedSuccess, 'active': step.number == currentStep }" v-for="(step, index) in formSteps" :key="index">
                                    <a href="#"><span>{{step.number}}</span></a>
                                </li>
                            </ul>
                        </div>
                        <div class="form-container" v-if="!formSubmittedSuccess">
                            <div class="form-step-container" :class="{ 'active': step.number == currentStep }" v-for="(step, index) in formSteps" :key="index" >
                                <component :is="step.componentName" :formData="formData" :defaultSettings="defaultSettings" :ref="'step' + step.number" @validation_response="onValidationResponse"></component>
                            </div>
                        </div>
                        <div class="form-container success" v-if="formSubmittedSuccess">
                            <div class="form-step-container">
                                <StepSuccess />
                                <div class="success-action">
                                    <button type="button" class="bax-btn bax-btn-blue-brand btn-success" @click.prevent="onFormRestart()" >Register another patient</button>
                                </div>
                            </div>
                        </div>
                        <div class="navigation-container" v-if="!formSubmittedSuccess">
                            <div class="buttons-left">
                                <button type="button" class="bax-btn bax-btn-bordered-blue-brand" v-if="showButton('back') && !formSubmitting" @click.prevent="onFormNavigate('back')">Back</button>
                            </div>
                            <div class="buttons-right">
                                <button type="button" class="bax-btn bax-btn-bordered-blue-brand" v-if="showButton('cancel') && !formSubmitting" @click.prevent="onFormCancel()">Cancel registration</button>
                                <button type="button" class="bax-btn bax-btn-bordered-blue-brand" v-if="showButton('print') && !formSubmitting" @click.prevent="onFormPrint()">Print form</button>
                                <button type="button" class="bax-btn bax-btn-blue-brand-2" v-if="showButton('save') && !formSubmitting" @click.prevent="onFormSave()">Save for later</button>
                                <button type="button" class="bax-btn bax-btn-blue-brand" v-if="showButton('next') && !formSubmitting" @click.prevent="onFormNavigate('next')">Next</button>
                                <button type="button" class="bax-btn bax-btn-blue-brand" :class="{ 'loading': formSubmitting }" v-if="showButton('submit')" @click.prevent="onFormSubmit()">Submit</button>
                            </div>
                        </div>
                        <div class="feedback" v-if="formSubmitFeedback"><p>{{formSubmitFeedback}}</p></div>
                    </div>
                    <CancelRegistationModal class="cancel-registration-modal" :open="modalCancelOpen" :type="formData.patient_type" :patientFormId="patientFormId" @modal_cancel_response="onModalCancelResponse"/>
                    <SaveRegistationModal class="save-registration-modal" :open="modalSaveOpen" :formData="formData" :patientFormId="patientFormId" @modal_save_close="onModalSaveClose"/>
                    <DeleteRegistationModal class="delete-registration-modal" :open="modalDeleteOpen" :deleteRequestItem="deleteRequestItem" @modal_delete_close="onModalDeleteClose"/>
                </div>
            </div>
        </main>
    </AppLayout>
</template>

<script>
import { mapGetters } from 'vuex';
import AppLayout from '@/components/layout/AppLayout.vue';
import BaxHeaderBannerSimple from '@/components/layout/BaxHeaderBannerSimple.vue';
import FormStep1 from '@/views/Tpn/PatientRegister/FormStep1.vue';
import FormStep2 from '@/views/Tpn/PatientRegister/FormStep2.vue';
import FormStep3 from '@/views/Tpn/PatientRegister/FormStep3.vue';
import FormStep4 from '@/views/Tpn/PatientRegister/FormStep4.vue';
import FormStep5 from '@/views/Tpn/PatientRegister/FormStep5.vue';
import FormStep6 from '@/views/Tpn/PatientRegister/FormStep6.vue';
import FormStep7 from '@/views/Tpn/PatientRegister/FormStep7.vue';
import FormStep8 from '@/views/Tpn/PatientRegister/FormStep8.vue';
import StepSuccess from '@/views/Tpn/PatientRegister/StepSuccess.vue';
import CancelRegistationModal from '@/views/Tpn/PatientRegister/CancelRegistationModal.vue';
import SaveRegistationModal from '@/views/Tpn/PatientRegister/SaveRegistationModal.vue';
import DeleteRegistationModal from '@/views/Tpn/PatientRegister/DeleteRegistationModal.vue';
import { scrollPageToTop, scrollPageToFirstError } from '@/core/helpers';
import PatientRegistationService from '@/core/api/tpn/patientRegistation.service';

export default {
    name: 'PatientRegister',
    components: {
        AppLayout,
        BaxHeaderBannerSimple,
        FormStep1,
        FormStep2,
        FormStep3,
        FormStep4,
        FormStep5,
        FormStep6,
        FormStep7,
        FormStep8,
        StepSuccess,
        CancelRegistationModal,
        SaveRegistationModal,
        DeleteRegistationModal,
    },
    data() {
        return {
            formSteps: [
                {
                    number: 1,
                    componentName: 'FormStep1',
                    buttons: {
                        back: false,
                        cancel: true,
                        save: true,
                        next: true,
                    },
                },
                {
                    number: 2,
                    componentName: 'FormStep2',
                    buttons: {
                        back: true,
                        cancel: true,
                        save: true,
                        next: true,
                    },
                },
                {
                    number: 3,
                    componentName: 'FormStep3',
                    buttons: {
                        back: true,
                        cancel: true,
                        save: true,
                        next: true,
                    },
                },
                {
                    number: 4,
                    componentName: 'FormStep4',
                    buttons: {
                        back: true,
                        cancel: true,
                        save: true,
                        next: true,
                    },
                },
                {
                    number: 5,
                    componentName: 'FormStep5',
                    buttons: {
                        back: true,
                        cancel: true,
                        save: true,
                        next: true,
                    },
                },
                {
                    number: 6,
                    componentName: 'FormStep6',
                    buttons: {
                        back: true,
                        cancel: true,
                        save: true,
                        next: true,
                    },
                },
                {
                    number: 7,
                    componentName: 'FormStep7',
                    buttons: {
                        back: true,
                        cancel: true,
                        save: true,
                        next: true,
                    },
                },
                {
                    number: 8,
                    componentName: 'FormStep8',
                    buttons: {
                        back: true,
                        cancel: true,
                        print: true,
                        save: true,
                        submit: true,
                    },
                },
            ],
            formData: {
                form_current_step: 1,
                // step 1 fields
                patient_type: 'nutrition',
                patient_first_name: '',
                patient_last_name: '',
                patient_dob: '',
                patient_country: this.$store.state.auth.user.hospitalCountry,
                patient_nhi_number: '',
                patient_address: '',
                patient_suburb: '',
                patient_state: '',
                patient_town_city: '',
                patient_postcode: '',
                patient_email: '',
                patient_phone: '',
                patient_phone_alt: '',
                delivery_day: '',
                // step 2 fields
                alt_contact_first_name: '',
                alt_contact_last_name: '',
                alt_contact_relationship: '',
                alt_contact_email: '',
                alt_contact_phone: '',
                alt_contact_phone_alt: '',
                // step 3 fields
                referring_hospital: '',
                coordinator_first_name: '',
                coordinator_last_name: '',
                coordinator_job_title: '',
                coordinator_phone: '',
                coordinator_email: '',
                additionalHCPContacts: [],
                // step 4 fields
                charged_to_input: '',
                charged_to_radio: 'health benefits',
                charged_to_radio_other_specify: '',
                po_number: '',
                consumables_charged_to: '',
                consumables_po_number: '',
                billing_contact: '',
                billing_phone: '',
                billing_email: '',
                billing_contact2: '',
                billing_phone2: '',
                billing_email2: '',
                // step 5 fields
                pump_type: '',
                pump_qty: '',
                pump_delivery_date: '',
                pump_deliver_to: '',
                pump_delivery_address: '',
                pump_giving_set_required: 'yes',
                pump_giving_set_type: '',
                pump_accessories_list: [{ name: '' }],
                // step 6 fields
                pump_training: 'yes',
                date_discharge: '',
                date_training: '',
                // step 7 fields
                consumables_list: [{ name: '', qty: '', frequency: '' }],
                consumables_notes: '',
                // step 8 fields
                terms_1: false,
                terms_2: false,
                terms_3: false,
                terms_4: false,
            },
            patientFormId: false,
            currentStep: 1,
            validForm: true,
            formSubmitting: false,
            formSubmittedSuccess: false,
            modalCancelOpen: false,
            modalSaveOpen: false,
            modalDeleteOpen: false,
            deletedConfirmationMessage: false,
            defaultSettings: {
                userDefaultHospital: '',
                userDefaultFirstName: '',
                userDefaultLastName: '',
                userDefaultJobTitle: '',
                userDefaultPhonenumber: '',
                userDefaultEmailAddress: '',
                pumpsList: [],
                states: [],
                consumables: [],
            },
            test: '',
            showIntro: false,
            asyncDataLoaded: false,
            draftApplications: [],
            deleteRequestItem: false,
            formSubmitFeedback: false,
        };
    },
    computed: {
        ...mapGetters(['authenticatedUser']),
    },
    created() {
        scrollPageToTop();

        PatientRegistationService.getPatientRegistationFormInfo()
        .then((res) => {
            const { data } = res;
            this.defaultSettings = data;
            this.formData.referring_hospital = this.defaultSettings.userDefaultHospital;
            this.formData.coordinator_first_name = this.defaultSettings.userDefaultFirstName;
            this.formData.coordinator_last_name = this.defaultSettings.userDefaultLastName;
            this.formData.coordinator_job_title = this.defaultSettings.userDefaultJobTitle;
            this.formData.coordinator_phone = this.defaultSettings.userDefaultPhonenumber;
            this.formData.coordinator_email = this.defaultSettings.userDefaultEmailAddress;
            this.asyncDataLoaded = true;

            if (data.draftApplications.length) {
                this.draftApplications = data.draftApplications;
                this.showIntro = true;
            }
        });
    },
    methods: {
        onValidationResponse(response) {
            this.validForm = response;
            if (!this.validForm) {
                this.$nextTick(() => scrollPageToFirstError('form-error'));
            }
        },
        showButton(type) {
            return this.formSteps[this.currentStep - 1].buttons[type];
        },
        onFormNavigate(direction) {
            if (direction === 'next') {
                this.$refs['step' + this.currentStep][0].validateForm();
            } else {
                this.validForm = true;
            }

            if (this.validForm) {
                this.deletedConfirmationMessage = false;
                if (direction === 'next') {
                    this.currentStep += 1;
                }
                if (direction === 'back') {
                    this.currentStep -= 1;
                }
                if (this.currentStep < 1) {
                    this.currentStep = 1;
                }
                if (this.currentStep > this.formSteps.length) {
                    this.currentStep = this.formSteps.length;
                }
                this.formData.form_current_step = this.currentStep;
                scrollPageToTop();
            }
        },
        onFormSubmit() {
            this.$refs['step' + (this.formSteps.length)][0].validateForm();

            if (this.validForm) {
                this.formSubmitting = true;
                const payload = {
                    formData: this.formData,
                    patientFormId: this.patientFormId,
                };
                PatientRegistationService.createPatientRegistation(payload)
                .then((res) => {
                    if (res.data.error) {
                        this.formSubmitFeedback = 'Sorry, something went wrong';
                        this.formSubmitting = false;
                    } else {
                        this.formSubmittedSuccess = true;
                    }
                })
                .catch((err) => {
                    if (err.response.status === 400) {
                        this.formSubmitFeedback = 'Sorry, something went wrong';
                        this.formSubmitting = false;
                    }
                });
            }
        },
        onFormPrint() {
            const originalTitle = document.title;
            document.title = originalTitle + ' - ' + this.formData.patient_first_name + ' ' + this.formData.patient_first_name;
            window.print();
            document.title = originalTitle;
        },
        onFormSave() {
            if (this.currentStep === 1) {
                this.$refs.step1[0].validateForm();
            } else {
                this.validForm = true;
            }

            if (this.validForm) {
                this.modalSaveOpen = true;
            }
        },
        onFormCancel() {
            this.modalCancelOpen = true;
        },
        onFormRestart() {
            window.location.reload();
        },
        onstartPatientRegistration() {
            this.deletedConfirmationMessage = false;
            this.showIntro = false;
        },
        onModalCancelResponse() {
            this.modalCancelOpen = false;
        },
        onModalSaveClose() {
            this.modalSaveOpen = false;
        },
        onModalDeleteClose(deletedId) {
            let appType = '';
            let appName = '';
            if (deletedId) {
                // find matching item
                const appItem = this.draftApplications.find((app) => app.id === deletedId);
                if (appItem) {
                    appType = appItem.type;
                    appName = appItem.name;
                    this.draftApplications = this.draftApplications.filter((app) => app.id !== deletedId);
                }
            }
            if (!this.draftApplications.length) {
                this.$router.push({ name: 'homeTPN', query: { registrationDelete: 1 } });
            } else {
                this.deletedConfirmationMessage = 'Home ' + appType + ' Patient registration for ' + appName + ' has been deleted';
                this.modalDeleteOpen = false;
                this.deleteRequestItem = false;
            }
        },
        onEditApplication(loadId) {
            const appItem = this.draftApplications.find((app) => app.id === loadId);
            if (appItem) {
                this.patientFormId = appItem.id;
                this.formData = JSON.parse(appItem.formData);
                this.showIntro = false;
                this.deletedConfirmationMessage = false;

                this.currentStep = this.formData.form_current_step;
            }
        },
        onDeleteApplication(application) {
            this.modalDeleteOpen = true;
            this.deleteRequestItem = application;
        },
    },
};
</script>
